import { render, staticRenderFns } from "./ManagementExpense.vue?vue&type=template&id=bf5f5cb0&scoped=true&"
import script from "./ManagementExpense.vue?vue&type=script&lang=ts&"
export * from "./ManagementExpense.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementExpense.vue?vue&type=style&index=0&id=bf5f5cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5f5cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
